import { MODULE_NAME } from '@ajs/config/constants';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { AppComponent } from '@app/app.component';
import { WellFooterComponent } from '@app/core-legacy/components/well-footer/well-footer.component';
import { WellHeaderComponent } from '@app/core-legacy/components/well-header/well-header.component';
import { WellComponent } from '@app/core-legacy/components/well/well.component';
import { FdxUtilsService } from '@app/core/services/fdx-utils.service';
import { FtpLiabilityAcceptanceService } from '@app/core/services/ftp-liability-acceptance.service';
import { ErrorOverviewPageComponent } from '@app/error-overview/pages/error-overview-page/error-overview-page.component';
import { ExportDeduplicateFieldsComponent } from '@app/exports-legacy/components/export-deduplicate-fields/export-deduplicate-fields.component';
import { ExportFieldsComponent } from '@app/exports-legacy/components/export-fields/export-fields.component';
import { ExportsPageComponent } from '@app/exports-legacy/pages/exports-page/exports-page.component';
import { EffectiveUserSelectComponent } from '@app/feed-support/components/effective-user-select/effective-user-select.component';
import { AlertComponent } from '@app/modules/alerts/components/alert/alert.component';
import { CodeInputComponent } from '@app/modules/inputs/components/code-input/code-input.component';
import { CollapsibleCodeComponent } from '@app/modules/inputs/components/collapsible-code/collapsible-code.component';
import { ExportSelectComponent } from '@app/modules/inputs/components/export-select/export-select.component';
import { FormFieldComponent } from '@app/modules/inputs/components/form-field/form-field.component';
import { InputWrapperComponent } from '@app/modules/inputs/components/input-wrapper/input-wrapper.component';
import { BreadcrumbsComponent } from '@app/modules/nav/components/breadcrumbs/breadcrumbs.component';
import { PageTitleComponent } from '@app/modules/page/components/page-title/page-title.component';
import { PaginationComponent } from '@app/modules/pagination/components/pagination/pagination.component';
import { PopoverHeaderComponent } from '@app/modules/popovers/components/popover-header/popover-header.component';
import { AdvancedQueryComponent } from '@app/modules/query/components/advanced-query/advanced-query.component';
import { BasicTransformerFieldComponent } from '@app/modules/query/components/basic-transformer-field/basic-transformer-field.component';
import { BasicTransformerComponent } from '@app/modules/query/components/basic-transformer/basic-transformer.component';
import { Bs3ContainerComponent } from '@app/standalone-components/bs3-container/bs3-container.component';
import { ClearableChipComponent } from '@app/standalone-components/chips/clearable-chips/clearable-chip.component';
import { SpinnerComponent } from '@app/standalone-components/spinner/spinner.component';
import { StickyHeaderComponent } from '@app/standalone-components/sticky-header/sticky-header.component';
import { StyleWrapperComponent } from '@app/standalone-components/style-wrapper/style-wrapper.component';
import { TransformersBulkImportPageComponent } from '@app/transformers/pages/transformers-bulk-import-page/transformers-bulk-import-page.component';
import { TransformersFieldOrderPageComponent } from '@app/transformers/pages/transformers-field-order-page/transformers-field-order-page.component';
import { EmptyStateComponent } from '@feedonomics/frontend-components';
import * as angular from 'angular';

angular
    .module(MODULE_NAME)
    .directive(
        'fdxRoot',
        downgradeComponent({ component: AppComponent }) as angular.IDirectiveFactory
    );

const components = [
    {
        directive: 'fdxStyleWrapper',
        component: StyleWrapperComponent
    },
    {
        directive: 'fdxExportsPage',
        component: ExportsPageComponent
    },
    {
        directive: 'fdxBs3Container',
        component: Bs3ContainerComponent
    },
    {
        directive: 'fdxTransformersBulkImportPage',
        component: TransformersBulkImportPageComponent
    },
    {
        directive: 'fdxTransformersFieldOrderPage',
        component: TransformersFieldOrderPageComponent
    },
    {
        directive: 'fdxErrorOverviewPage',
        component: ErrorOverviewPageComponent
    }
];

components.forEach(({ directive, component }) => {
    angular.module(MODULE_NAME).directive(directive, downgradeComponent({ component }) as angular.IDirectiveFactory);
});

// non-page components

// TODO: Remove AdvancedQueryComponent from here after deleting legacy data page
angular.module(MODULE_NAME).directive('fdxAdvancedQuery', downgradeComponent({
    component: AdvancedQueryComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxBasicTransformer', downgradeComponent({
    component: BasicTransformerComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxBasicTransformerFieldComponent', downgradeComponent({
    component: BasicTransformerFieldComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxCodeInput', downgradeComponent({
    component: CodeInputComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxCollapsibleCode', downgradeComponent({
    component: CollapsibleCodeComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxPageTitle', downgradeComponent({
    component: PageTitleComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxClearableChip', downgradeComponent({
    component: ClearableChipComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxSpinner', downgradeComponent({
    component: SpinnerComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxAlert', downgradeComponent({
    component: AlertComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxStickyHeader', downgradeComponent({
    component: StickyHeaderComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxPagination', downgradeComponent({
    component: PaginationComponent,
    inputs: ['pageCount', 'pageSize', 'page', 'size'],
    outputs: ['selectPage']
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxPopoverHeader', downgradeComponent({
    component: PopoverHeaderComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxEffectiveUserSelect', downgradeComponent({
    component: EffectiveUserSelectComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxExportDeduplicateFields', downgradeComponent({
    component: ExportDeduplicateFieldsComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxExportFields', downgradeComponent({
    component: ExportFieldsComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxExportSelect', downgradeComponent({
    component: ExportSelectComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxFormField', downgradeComponent({
    component: FormFieldComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxInputWrapper', downgradeComponent({
    component: InputWrapperComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fscEmptyState', downgradeComponent({
    component: EmptyStateComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxWell', downgradeComponent({
    component: WellComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxWellHeader', downgradeComponent({
    component: WellHeaderComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxWellFooter', downgradeComponent({
    component: WellFooterComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).directive('fdxBreadcrumbs', downgradeComponent({
    component: BreadcrumbsComponent
}) as angular.IDirectiveFactory);

angular.module(MODULE_NAME).factory('fdxUtilsService', downgradeInjectable(FdxUtilsService));

angular.module(MODULE_NAME).factory('fdxLiabilityAcceptanceService', downgradeInjectable(FtpLiabilityAcceptanceService));
